/** admin/cohorts — KEYS. */
export const adminCohortsKeys = {
  all: () => ['admin', 'cohorts'] as const,
  lists: () => [...adminCohortsKeys.all(), 'list'] as const,
  detail: (id: string) => [...adminCohortsKeys.all(), 'detail', id] as const,
};
